import { AnimatePresence, motion } from "motion/react";
import { FC, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { LOCALES } from "./i18n";

import styles from './LanguageSwitcher.module.css';

export const LanguageSwitcher: FC = () => {

    const { i18n } = useTranslation();

    const current = i18n.language;

    const [
        expanded,
        setExpanded
    ] = useState<boolean>(false);

    const handleOpen = useCallback(() => {
        setExpanded(true);
    }, [setExpanded]);

    const duration = useMemo(() => 0.15, []);

    const languages = useMemo(() => {
        return Object.values(LOCALES).map(locale => {
            return {
                code: locale.code,
                name: locale.name,
                isActive: locale.code === current,
                set: () => {
                    i18n.changeLanguage(locale.code);
                    setTimeout(() => setExpanded(false), 1000 * duration);
                }
            }
        });
    }, [current, i18n, setExpanded, duration]);

    return <>
        <button
            onClick={handleOpen}
        >{current.toUpperCase()}</button>

        <AnimatePresence>
            {expanded &&
                <motion.div
                    initial={{ opacity: 0, scale: 1.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 1.95 }}
                    transition={{ duration: duration }}
                    className={styles.container}
                >
                    {languages.map(lang => {
                        return <button onClick={lang.set}>{lang.name}</button>
                    })}
                </motion.div>
            }
        </AnimatePresence>
    </>;

}